/* RESPONSIBLE TEAM: team-phone */
import type PhoneCallCsatRequest from 'embercom/models/operator/visual-builder/step/phone-call-csat-request';
import StepConfig, { type StepConfigParams } from '../step';

export default class PhoneCallCsatRequestConfiguration extends StepConfig {
  declare step: PhoneCallCsatRequest;

  constructor(params: Omit<StepConfigParams, 'component'> & { component?: string }) {
    super({
      component: 'workflows/graph-editor/node-items/steps/phone-call-csat-request',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
